import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import core from "../core/core.module";
import organization from "./organization";
import organizationForm from "./organization-form/organization-form";
import refillBalanceForm from "./refill-balance-form/refill-balance-form";
import notify from "@cgross/angular-notify";
import organizationTransactions from "./organization-transactions/organizations-transactions";

angular
    .module('organizationsControl.component', [
        angularUIB,
        core,
        organization,
        organizationForm,
        refillBalanceForm,
        notify,
        organizationTransactions
    ])
    .component('organizationsControl', {
        controller: ['$uibModal', 'notifier', 'Organization', 'Auth', '$rootScope', 'notify', controller],
        template: require('./organizations-control.component.html'),
        bindings: {
            agregator: '<',
            organizationsBalance: '<',
        }
    });

function controller($uibModal, notifier, Organization, Auth, $rootScope, notify) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentPage = 1;
        $ctrl.search = null;
        $ctrl.getList();
    };

    $ctrl.doFilter = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.clearFilter = function () {
        $ctrl.currentPage = 1;
        $ctrl.search = null;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        Organization
            .getList({
                currentPage: $ctrl.currentPage,
                search: $ctrl.search
            })
            .then(
                function (response) {
                    $ctrl.organizations = response.data.organizations;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.openOrganizationForm = function (organization) {
        if (!Auth.can('organizations_control.crud')) {
            return;
        }

        $uibModal
            .open({
                component: 'organizationForm',
                resolve: {
                    organization: function () {
                        return organization;
                    }
                }
            })
            .result
            .finally(() => {
                $ctrl.getList();
            });
    };

    $ctrl.openBalanceForm = function (organization) {
        if (!Auth.can('organizations_control.refill_balance')) {
            return;
        }

        $uibModal.open({
            component: 'refillBalanceForm',
            resolve: {
                agregatorBalance: function () {
                    return $ctrl.agregator.balance;
                },
                organization: function () {
                    return organization
                }
            }
        });
    };

    // $rootScope.$on('transaction.executed', function (event, data) {
    //     let orgId = data.transaction.organization_id;
    //
    //     for (let i = 0; i < $ctrl.organizations.length; i++) {
    //         if ($ctrl.organizations[i].id === orgId) {
    //             updateBalanceData($ctrl.organizations[i]);
    //             return;
    //         }
    //     }
    //
    //     if ($ctrl.agregator.id === orgId) {
    //         updateBalanceData($ctrl.agregator);
    //     }
    // });

    function updateBalanceData(org) {
        Organization
            .getBalanceData(org.id)
            .then(
                function (response) {
                    org.balance = response.data.currentBalance;
                    org.balanceInfo.startOfDay = response.data.balanceInfo.startOfDay;
                    org.balanceInfo.todayRefill = response.data.balanceInfo.todayRefill;
                    org.balanceInfo.todayTurnover = response.data.balanceInfo.todayTurnover;
                }
            );
    }

    $ctrl.openTransactionsList = function (org) {
        $uibModal.open({
            component: 'organizationTransactions',
            resolve: {
                organization: function () {
                    return org
                }
            },
            size: 'lg'
        });
    };
}

export default 'organizationsControl.component';


// WEBPACK FOOTER //
// ./resources/assets/modules/organizations-control/organizations-control.component.js